import axios from "axios";
import { idText } from "typescript";
import { getToken, getUser } from "../Utils/Common";
import { getWithParamsAPICall, postAPICall } from "./axiosMethodCalls";
import { getRestoLogin } from "../Utils/Common";
import { UsePostRequest } from "../hooks/UsePostApiCall";

/***************************
 * LOGIN
 ***************************/

//GET
export const loginUser = async (username, password, restoType) => {
    try {
        if (restoType === "hanamaruken") {
            const response = await postAPICall(
                process.env.REACT_APP_BRIQUE_API + "login/index",
                {
                    username: username,
                    password: password,
                    terminal: 1
                }
            );
            return { data: response.data };
        } else {
            const response = await postAPICall(
                process.env.REACT_APP_ETTAS_API + "login/index",
                {
                    username: username,
                    password: password,
                    terminal: 1
                }
            );
            return { data: response.data };
        }
    } catch (error) {
        return { error: error.response };
    }
};

export const loginAuthorize = async (username, password, terminal, restoType) => {
    try {
        if (getRestoLogin()==="hanamaruken") {
            const response = await postAPICall(
                process.env.REACT_APP_BRIQUE_API + "authenticate/index",
                {
                    username: username,
                    password: password,
                    terminal: "1",
                }
            );
            return { data: response.data };
        } else {
            const response = await postAPICall(
                process.env.REACT_APP_ETTAS_API + "authenticate/index",
                {
                    username: username,
                    password: password,
                    terminal: "1",
                }
            );
            return { data: response.data };
        }
    } catch (error) {
        return { error: error.response };
    }
};

/***************************
 * LOGOUT
 ***************************/

export const logoutUser = async (restoType) => {
    try {
        const response = await postAPICall(
            getRestoLogin()==="hanamaruken"?process.env.REACT_APP_BRIQUE_API + "logout/index/" + getUser():
            process.env.REACT_APP_ETTAS_API + "logout/index/" + getUser(),
            {
                requester: getUser(),
                token: getToken(),
            }
        );
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};

export const resyncData = async () => {
    try {
        const response = await getWithParamsAPICall(
            process.env.REACT_APP_BRIQUE_API + "online/sync",
            {
                requester: getUser(),
                token: getToken(),
            }
        );
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};

export const recordUserActivityLog = async (activity) => {
    try {
        const payload = {
            requester: getUser(),
            activity: activity,
        }
        const response = await UsePostRequest("users/activity_logs", payload, false, getRestoLogin())
    } catch (error) {
        console.log(error)
    }
}